import { render, staticRenderFns } from "./ClaimYourProfilePage.vue?vue&type=template&id=8777484a&scoped=true"
import script from "./ClaimYourProfilePage.vue?vue&type=script&lang=js"
export * from "./ClaimYourProfilePage.vue?vue&type=script&lang=js"
import style0 from "./ClaimYourProfilePage.vue?vue&type=style&index=0&id=8777484a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8777484a",
  null
  
)

export default component.exports